import { actions } from "@src/Actions/Reducers/GlobalModalsReducer"
import { LocaleSelect } from "@src/Components/LocaleSelect"
import { useLocale } from "@src/Hooks/useLocale"
import { VIEW_PATHS } from "@src/Routes/constants"
import { MenuGroup, Section, SideNav } from "@zeguro/component-library"
import { Locale as ILocale } from "@zeguro/schema-validator/dist/types/coco/core/combined"
import * as React from "react"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"

import { IAvatarData, IGroupItem } from "../MenuContainer"

interface IMenu {
  avatarData: IAvatarData
  menuItems: IGroupItem[]
  width: number
  offset?: number
  hidden: boolean
  isOpen: boolean
  logo: string
  setView: (view: string) => void
}

const Menu = ({
  avatarData,
  menuItems,
  width,
  offset,
  hidden,
  isOpen,
  logo,
  setView,
}: IMenu) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const pathname = `/${history.location.pathname.split("/")[1]}`
  const view = Object.entries(VIEW_PATHS).find(([, v]) => v === pathname)?.[0]
  const { currentLocale } = useLocale()
  const groupsList = menuItems.map((group) => group.value)
  const [expandedGroups, setExpandedGroups] =
    React.useState<string[]>(groupsList)

  const handleLocaleChange = (newLocale: ILocale) => {
    if (currentLocale !== newLocale) {
      dispatch(actions.openLanguageModal(newLocale))
    }
  }

  const toggleGroup = (index: number) => {
    const group = menuItems[index]
    if (group?.value) {
      setExpandedGroups((prev) =>
        prev.includes(group.value!)
          ? prev.filter((id) => id !== group.value)
          : [...prev, group.value!],
      )
    }
  }

  React.useEffect(() => {
    const viewGroup = menuItems.find((group) =>
      group.groupItems.find((item) => item.value === view),
    )?.value
    if (viewGroup && !expandedGroups.includes(viewGroup)) {
      setExpandedGroups([...expandedGroups, viewGroup])
    }
  }, [view])

  return (
    <SideNav
      avatar={avatarData}
      width={width}
      offset={offset}
      hidden={hidden}
      isOpen={isOpen}
      partnerLogoUrl={logo || "/images/zeguro_logo.svg"}
      isCustomLogo={!!logo}
    >
      <>
        <MenuGroup
          menuItemsGroup={menuItems}
          selectedItem={view}
          onSelect={(view) => setView(view)}
          isExact={false}
          onToggleGroup={toggleGroup}
          expandedGroups={expandedGroups}
        />
        <Section padding="12px 16px">
          <LocaleSelect
            value={currentLocale}
            onChange={handleLocaleChange}
            maxWidth="215px"
            menuPlacement="bottom"
          />
        </Section>
      </>
    </SideNav>
  )
}

export default Menu
